module.exports = __webpack_public_path__ + "img/ysf.dbdf047a.jpg";